"use strict";exports.h=e=>Object.keys(e||{}).length>0;